export default {
  CARD_MIN_LENGTH: 8,
  CARD_MAX_LENGTH: 12,
  PINMAXLENGTH: 5,
};
